import React, { useState } from "react";
import { DashboardNotificationSection } from "../MainDashboard/DashboardNotificationSection";
import DEATH_API from "../../apis/death.api";
import Loader from "../../components/styled-components/loader/loader";
import swal from "sweetalert";
import "./Feedback.css";

export const Feedback = () => {
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const handlechange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submit...", formData);
    try {
      setLoading(true);
      console.log("obj in playload update", formData);
      const response= await DEATH_API.sendFeedback(formData);
      console.log("response",response)
      if(response.status===200){
        swal("Success", response.message, "success")
      }
      if(response.status===400){
        swal("Oops!", response.message, "error")
      }
      setLoading(false);
      setFormData(null);
    } catch (error) {
      console.log("error in update", error);
      setLoading(false);
    }
    setFormData({
        name: "",
        email: "",
        feedback: "",
      });
  };

  return (
    <div style={{ display: "flex" }}>
      <div
        className="MainDashboard1"
        style={{
          background: "white",
          borderRadius: "8px",
          marginBottom: "2rem",
          width:"100%",
        }}
      >
        <div className="feedbackMainHeading">Send us Your Feedback</div>
        <div className="feedbackSubMainHeading">
          Your feedback can be anonymous, no need to add email address or name
          if you do not wish to.
        </div>
        <div style={{ marginTop: "1rem" }}>
          This feedback form goes directly to{" "}
          <a style={{ color: "#2a3da3" }} href="mailto:support@assetplanet.com">
            support@assetplanet.com
          </a>{" "}
          and you can contact us there if you have other questions or concerns.
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ width: "50%", marginTop: "1rem", marginLeft:"2rem" }}>
            <div style={{ marginTop: "8px" }}>
              <div className="fieldsLable">Name</div>
              <input
                className="inputFieldClass"
                style={{ width: "100%" }}
                placeholder="Name"
                type="text"
                value={formData && formData.name}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="name"
              />
            </div>
            <div style={{ marginTop: "8px" }}>
              <div className="fieldsLable">Email</div>
              <input
                className="inputFieldClass"
                style={{ width: "100%" }}
                placeholder="Email"
                type="email"
                value={formData && formData.email}
                onChange={(e) => {
                  e.preventDefault();
                  e.persist();
                  if (!isValidEmail(e.target.value)) {
                    if (e.target.value === "") {
                      setError(null);
                    } else {
                      setError("Email is invalid");
                    }
                  } else {
                    setError(null);
                  }
                  handlechange(e.target.name, e.target.value);
                }}
                name="email"
              />
              {error && (
                <span style={{ color: "red", fontSize: "12px" }}>{error}</span>
              )}
            </div>
            <div style={{ marginTop: "8px" }}>
              <div className="fieldsLable">
                Feedback<span style={{ color: "red" }}>*</span>
              </div>
              <textarea
                className="inputFieldClass"
                style={{ width: "100%" }}
                placeholder="Feedback"
                rows={4}
                value={formData && formData.feedback}
                onChange={(e) => {
                  e.preventDefault();
                  handlechange(e.target.name, e.target.value);
                }}
                name="feedback"
              />
            </div>
            <button
              className="feedbackButton"
              type="submit"
              disabled={formData && formData.feedback ? false : true}
              style={{
                opacity: formData && formData.feedback ? "1": "0.5",
                cursor: formData && formData.feedback ? "pointer" : "not-allowed"
              }}
                // onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
     {/* <div className="notificationMain">
        <DashboardNotificationSection />
        </div> */}
      <Loader isLoading={loading} />
    </div>
  );
};
